module.exports = __webpack_public_path__ + "ae4cc65f28686cf3e5a4a82d942f5729.png";